export class PersonenUndStellenbezogeneMerkmaleM2 {
  alterMaenner: number;
  alterFrauen: number;
  anforderungAusbildungFrauen: number;
  anforderungAusbildungMaenner: number;
  anforderungAutonomieFrauen: number;
  anforderungAutonomieMaenner: number;
  anforderungKoerperlichFrauen: number;
  anforderungKoerperlichMaenner: number;
  anforderungPsychischFrauen: number;
  anforderungPsychischMaenner: number;

  anforderungVerantwortungFrauen: number;
  anforderungVerantwortungMaenner: number;
  anforderungWissenFrauen: number;
  anforderungWissenMaenner: number;
  anzahlFrauen: number;
  anzahlMaenner: number;
  dienstjahreFrauen: number;
  dienstjahreMaenner: number;
  differenzAbsolutAlter: number;
  differenzAbsolutAusbildung: number;
  differenzAbsolutAutonomie: number;
  differenzAbsolutDienstjahre: number;
  differenzAbsolutFunktionswert: number;
  differenzAbsolutKoerperlich: number;
  differenzAbsolutPsychisch: number;
  differenzAbsolutVerantwortung: number;
  differenzAbsolutWissen: number;
  differenzProzentAlter: string;
  differenzProzentAusbildung: string;
  differenzProzentAutonomie: string;
  differenzProzentDienstjahre: string;
  differenzProzentFunktionswert: string;
  differenzProzentKoerperlich: string;
  differenzProzentPsychisch: string;
  differenzProzentVerantwortung: string;
  differenzProzentWissen: string;
  funktionswertFrauen: number;
  funktionswertMaenner: number;
}
